import React, { useEffect, useState, useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import { setLastClick } from "../state/user/userSlice"
import store from "../state/store"
import { logoutAction, updateAlert } from "../state/login/loginSlice"
import { updateSelectedOrg } from "../state/organisation/organisationSlice"
import { updateSelectedClinic } from "../state/clinic/clinicSlice"
import { endLoginTimeTracker, updateTimeTracker } from "../state"
import { userLoggedOut } from "../state/rootReducer"
import { navigate } from "gatsby"
import CloseIcon from "@mui/icons-material/Close"
import {
    updateIsTimeTrackerForced,
    updateTime,
    updateTimerPlaying,
} from "../state/patient/patientSlice"
let GuidedTour = null
if (typeof window !== undefined) {
    GuidedTour = require("./GuidedTour").default
}

const Layout = ({ children }) => {
    const [showMessage, setShowMessage] = useState(false)
    const dispatch = useDispatch()
    const loggedIn = useSelector(state => state.login.loggedin)
    const subscriptionDetails = useSelector(
        state => state.login.subscriptionDetails
    )
    const user = useSelector(state => state.login.user)
    const intervalRef = useRef(null) // Reference for setInterval
    const alert = useSelector(state => state.login.alert)
    const timerPlaying = useSelector(state => state.patients.timerPlaying)
    const activePage =
        typeof window !== "undefined" ? window.location.pathname : "/"
    const [showFreeTrialPopup, setShowFreeTrialPopup] = useState(
        subscriptionDetails?.isFreeTrial
    )

    const createdDateStr = user?.organizationListForUser?.[0]?.created_date

    const getRemainingTrialDaysText = startDate => {
        if (!startDate) return ""

        const createdDate = new Date(startDate)
        const now = new Date()

        const diffInMs = now - createdDate
        const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24))

        const remainingDays = 90 - diffInDays

        if (remainingDays <= 0) return "today"
        if (remainingDays === 1) return "1 day"
        return `${remainingDays} days`
    }

    const remainingTrialText = getRemainingTrialDaysText(createdDateStr)

    useEffect(() => {
        if (process.env.GATSBY_URL_TYPE === "PROD") {
            console.log = () => {}
            console.warn = () => {}
            console.error = () => {}
            document.addEventListener("contextmenu", function (e) {
                e.preventDefault()
                return false
            })
        }
    }, [])

    // useEffect(() => {
    //     if (!loggedIn) {
    //         if (showMessage) setShowMessage(false)
    //         return
    //     }
    // Handle click and update Redux state
    // const handleClick = () => {
    //     localStorage.setItem("lastClicked", new Date().getTime() + "")
    //     dispatch(setLastClick(new Date().getTime()))
    // }

    // Attach click event listener
    // document.addEventListener("click", handleClick)

    // Start interval to check for inactivity
    // intervalRef.current = setInterval(async () => {
    //     const lastClickedTime = store.getState().user.lastClick
    //     const currentTime = new Date().getTime()
    //     const lc = await localStorage.getItem("lastClicked")
    //     if (lastClickedTime < new Date().getTime() - 1000 * 60 * 7) {
    //         if (lc < new Date().getTime() - 1000 * 60 * 7) {
    //             localStorage.setItem(
    //                 "lastClicked",
    //                 new Date().getTime() + ""
    //             )
    //             console.log(
    //                 activePage,
    //                 activePage.includes("/patients/patient"),
    //                 timerPlaying,
    //                 "dkjsfldsfjlds"
    //             )
    //             const token = JSON.parse(localStorage.getItem("userAuth"))
    //             // if (
    //             //     // activePage.includes("/patients/patient") &&
    //             //     timerPlaying
    //             // ) {
    //             dispatch(updateTimerPlaying(false))
    //             dispatch(updateIsTimeTrackerForced(false))
    //             dispatch(
    //                 updateTimeTracker(
    //                     true,
    //                     () => {},
    //                     () => {},
    //                     token
    //                 )
    //             )
    //             dispatch(updateTime(null))
    //             // }
    //             dispatch(logoutAction())
    //             dispatch(
    //                 updateSelectedOrg({
    //                     organizationId: null,
    //                     organizationName: "",
    //                 })
    //             )
    //             dispatch(
    //                 updateSelectedClinic({ clinicId: null, clinicName: "" })
    //             )
    //             dispatch(endLoginTimeTracker(false, token))
    //             dispatch(userLoggedOut())
    //             dispatch(setLastClick(new Date().getTime()))
    //             dispatch(
    //                 updateAlert({
    //                     ...alert,
    //                     open: true,
    //                     type: "error",
    //                     msg: "Logged out due to inactivity!",
    //                 })
    //             )
    //             navigate("/login")
    //             if (typeof window !== undefined) {
    //                 setTimeout(() => {
    //                     window.location.reload()
    //                 }, 10)
    //             }
    //         }
    //     }
    //     if (lastClickedTime < currentTime - 1000 * 60 * 5) {
    //         if (lc < currentTime - 1000 * 60 * 5) {
    //             if (!showMessage) setShowMessage(true) // Show message if inactive
    //         }
    //     } else {
    //         if (showMessage) setShowMessage(false) // Hide message if active
    //     }
    // }, 1000)

    // Cleanup event listener and interval on component unmount
    // return () => {
    //     document.removeEventListener("click", handleClick)
    //     if (intervalRef.current) {
    //         clearInterval(intervalRef.current)
    //     }
    // }
    // }, [dispatch, showMessage, loggedIn])

    useEffect(() => {
        localStorage.setItem("lastClicked", new Date().getTime() + "")
        dispatch(setLastClick(new Date().getTime()))
    }, [loggedIn])

    // useEffect(() => {
    //     console.log(user, subscriptionDetails, "klsfjldjfdsfdjfjsdl")
    //     setShowFreeTrialPopup(
    //         !subscriptionDetails?.subscription &&
    //             subscriptionDetails?.isFreeTrial
    //     )
    //     if (
    //         !subscriptionDetails?.isFreeTrial &&
    //         !subscriptionDetails?.subscription &&
    //         typeof window !== undefined &&
    //         !window.location.pathname.includes("success")
    //     ) {
    //         let userType = user?.profileForUser?.[0]?.profession_type_desc
    //         if (userType == "Therapist") {
    //             navigate("/subscriptions/subscribe")
    //         } else {
    //             if (userType) {
    //                 dispatch(logoutAction())
    //                 dispatch(
    //                     updateAlert({
    //                         ...alert,
    //                         open: true,
    //                         type: "error",
    //                         msg: "Please subscribe to a plan",
    //                     })
    //                 )
    //                 navigate("/login")
    //             }
    //         }
    //         return
    //     }
    // }, [subscriptionDetails])

    return (
        <div>
            {typeof window !== undefined && <GuidedTour />}
            {/* Display message if inactive */}
            {loggedIn && showMessage && (
                <div
                    style={{
                        position: "fixed",
                        background: "#FFAC1C",
                        color: "white",
                        padding: 15,
                        top: 20,
                        borderRadius: 5,
                        zIndex: 9999999,
                        alignSelf: "center",
                        left: "50%",
                        transform: "translate(-50%, 0)",
                    }}
                >
                    <p style={{ marginRight: 20 }}>
                        You will be logged out soon due to inactivity.
                    </p>
                    <CloseIcon
                        sx={{
                            position: "absolute",
                            right: 5,
                            top: 5,
                            cursor: "pointer",
                        }}
                    />
                </div>
            )}
            {/*showFreeTrialPopup && (
                <div
                    style={{
                        position: "fixed",
                        background: "#FFAC1C",
                        color: "white",
                        padding: 15,
                        top: 20,
                        borderRadius: 5,
                        zIndex: 9999999,
                        alignSelf: "center",
                        left: "50%",
                        transform: "translate(-50%, 0)",
                    }}
                >
                    <p style={{ marginRight: 20 }}>
                        Your free trial ends{" "}
                        {remainingTrialText === "today"
                            ? "today"
                            : `in ${remainingTrialText}`}
                        . Please{" "}
                        <span
                            style={
                                user?.profileForUser?.[0]
                                    ?.profession_type_desc === "Therapist"
                                    ? { color: "blue", cursor: "pointer" }
                                    : {}
                            }
                            onClick={() =>
                                user?.profileForUser?.[0]
                                    ?.profession_type_desc === "Therapist"
                                    ? navigate("/subscriptions/subscribe")
                                    : {}
                            }
                        >
                            subscribe
                        </span>{" "}
                        to continue using the platform.
                    </p>

                    <div
                        onClick={() =>
                            setShowFreeTrialPopup(!showFreeTrialPopup)
                        }
                    >
                        <CloseIcon
                            sx={{
                                position: "absolute",
                                right: 5,
                                top: 5,
                                cursor: "pointer",
                            }}
                        />
                    </div>
                </div>
            )*/}
            {children}
        </div>
    )
}

export default Layout
